export function checkoutUrlForMember(checkoutUrl: string, memberEmail?: string | null): string {
  const email = memberEmail?.trim()
  if (!email) return checkoutUrl
  try {
    const url = new URL(checkoutUrl)
    url.searchParams.set('email', email)
    url.searchParams.set('lockEmail', '1')
    return url.toString()
  } catch {
    return checkoutUrl
  }
}
